import React from 'react';
import { Mail, RotateCcw } from 'lucide-react';
export function RefundPolicy() {
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-1315">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1316">
        {/* Page Header */}
        <div className="mb-12" data-id="element-1317">
          <div className="flex items-center justify-center mb-4" data-id="element-1318">
            <RotateCcw className="w-12 h-12 text-brand-purple-600 mr-4" data-id="element-1319" />
            <h1 className="text-4xl font-bold text-gray-900" data-id="element-1320">REFUND POLICY</h1>
          </div>
        </div>

        {/* Policy Content */}
        <div className="bg-gray-50 rounded-lg p-8 mb-8" data-id="element-1321">
          <p className="text-lg leading-relaxed text-gray-700 mb-6" data-id="element-1322">
            Any request for refunds must be made in writing for verification.
            Any request will be handled on a case-by-case basis.
          </p>

          <div className="bg-white rounded-lg p-6 border-2 border-brand-purple-200" data-id="element-1323">
            <div className="flex items-start" data-id="element-1324">
              <Mail className="w-6 h-6 text-brand-purple-600 mr-3 mt-1 flex-shrink-0" data-id="element-1325" />
              <div data-id="element-1326">
                <p className="text-base text-gray-700 mb-2" data-id="element-1327">
                  Please email requests to:
                </p>
                <a href="mailto:customerservice@desertsageseminars.com" className="text-xl font-semibold text-brand-purple-600 hover:text-brand-purple-700" data-id="element-1328">
                  customerservice@desertsageseminars.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}